module.exports = __webpack_public_path__ + "img/akkodis-logo-letter.ef487057.svg";